export default __webpack_public_path__ + "static/media/TeamCred.02cec21a.svg";